var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c('AppModalInfo',{ref:"AppModalInfo",attrs:{"show":_vm.infoModal.show,"title":_vm.infoModal.title,"messages":_vm.infoModal.messages,"buttons":_vm.infoModal.buttons}}),_c('DashboardContent',{on:{"click":_vm.toggleSidebar}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }